import React from "react";
import InitialsAvatar from "react-initials-avatar";

const GenerationDetails = ({
  className,
  name,
  time,
}: {
  className: string;
  name: string | undefined;
  time: string | undefined;
}) => {
  return (
    <div className={`flex items-center gap-2` + " " + className}>
      <div className="bg-semantic-success rounded-full w-8 h-8 grid place-items-center text-white font-semibold">
        <InitialsAvatar name={name?.split(" ")[0] || "Anon"} />
      </div>
      <div className="space-x-2 flex">
        <p>{name}</p>
        <p>•</p>
        <p className="text-natural-grey-400">
          Created :{" "}
          {new Date(time || "").toDateString().split(" ").slice(1).join(" ")}
        </p>
      </div>
    </div>
  );
};

export default GenerationDetails;
